import config from './config';

export const fetchOfferCategories = async (branchId) => {
  const url = branchId ? `${config.API_BASE_URL}/categories?branchId=${branchId}` : `${config.API_BASE_URL}/categories`;
  const response = await fetch(url);
  const data = await response.json();
  // Match 'العروض:', 'offer', or 'deal' at the start of the name
  return data.filter(cat => /^(العروض:|offer|deal)/i.test(cat.CategoryName));
};
